import { render, staticRenderFns } from "./OpenTokSession.vue?vue&type=template&id=236e35d8&"
import script from "./OpenTokSession.vue?vue&type=script&lang=js&"
export * from "./OpenTokSession.vue?vue&type=script&lang=js&"
import style0 from "./OpenTokSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports